import { Checkbox as NextCheckbox, CheckboxProps } from '@nextui-org/react';
import styled, { css } from 'styled-components';

import { ThemeProp } from '../../theme/Themes';

const CHECKBOX_BORDER_WIDTH = `2px`;

const defaultCssRules = css`
  margin-top: 0 !important;

  .nextui-checkbox-container {
    flex-shrink: 0;
  }

  & .nextui-checkbox-text {
    padding: 0.625rem 0;
    padding-left: 0.5rem;
  }

  .nextui-checkbox-mask {
    &::before {
      border-color: ${({ theme }: ThemeProp) => theme.colors.neutrals.c200};
      border-width: ${CHECKBOX_BORDER_WIDTH}; // NOTE: Spec from design system.
      background: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
      border-radius: 0.25rem;
    }
    &::after {
      background: ${({ theme }: ThemeProp) => theme.colors.main.c600};
    }
  }

  &:hover {
    .nextui-checkbox-mask {
      &::before {
        background: ${({ theme }: ThemeProp) => theme.colors.main.c050};
        border-color: ${({ theme }: ThemeProp) => theme.colors.main.c200};
      }
    }
  }
`;

const disabledCssRules = css`
  opacity: 1 !important;

  .nextui-checkbox-container {
    opacity: 1 !important;
  }

  & .nextui-checkbox-text {
    padding: 0.625rem 0;
    padding-left: 0.5rem;
  }

  .nextui-checkbox-mask {
    &::after {
      background: ${({ theme }: ThemeProp) => theme && '#F5F4F5'}; // TODO: ds-colors-transitions: base/neutrals/100
      border: ${CHECKBOX_BORDER_WIDTH} solid ${({ theme }: ThemeProp) => theme && '#D6D4D8'}; // TODO: ds-colors-transitions: base/neutrals/300
    }

    .nextui-icon-check {
      .nextui-icon-check-line1 {
        &::after {
          background: ${({ theme }: ThemeProp) => theme && '#D6D4D8'}; // TODO: ds-colors-transitions: base/neutrals/300
        }
      }
      .nextui-icon-check-line2 {
        &::after {
          background: ${({ theme }: ThemeProp) => theme && '#D6D4D8'}; // TODO: ds-colors-transitions: base/neutrals/300
        }
      }
    }
  }
`;

export const Checkbox = styled(NextCheckbox).attrs((props) => ({
  ...props,
  size: 'sm',
  css: {
    '& .nextui-checkbox-text': {
      'font-size': '$xs2',
      'line-height': '$base2',
    },
  },
}))`
  ${({ isDisabled }: CheckboxProps) => (isDisabled ? disabledCssRules : defaultCssRules)}
`;

export default Checkbox;

export const CheckboxGrouped = styled(Checkbox).attrs((props) => ({
  ...props,
  css: {
    '& .nextui-checkbox-container': {
      height: '$9',
      width: '$9',
    },
    '& .nextui-checkbox-text': {
      width: '100%',
    },
  },
}))``;

export const CheckboxNotGrouped = styled(Checkbox).attrs((props) => ({
  ...props,
  css: {
    marginRight: 0,
    '& .nextui-checkbox-container': {
      height: '$9',
      width: '$9',
      overflow: 'visible',
    },
    '& .nextui-checkbox-text': {
      overflow: 'hidden',
      display: 'flex',
      flex: 1,
    },
    '& .nextui-checkbox-label': {
      marginRight: 0,
    },
  },
}))``;
